var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaste24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 3.00131L15.8198 3.00097C15.3999 1.84093 14.3 1.00084 13 1.00074C11.7 1.00063 10.5999 1.84054 10.1798 3.00051L5.99984 3.00016C4.89984 3.00007 3.99976 3.9 3.99967 5L3.99836 21C3.99827 22.1 4.8982 23.0001 5.9982 23.0002L19.9982 23.0013C21.0982 23.0014 21.9983 22.1015 21.9984 21.0015L21.9997 5.00148C21.9998 3.90148 21.0998 3.0014 19.9998 3.00131ZM12.9998 3.00074C13.5498 3.00078 13.9998 3.45082 13.9998 4.00082C13.9997 4.55082 13.5497 5.00078 12.9997 5.00074C12.4497 5.00069 11.9997 4.55066 11.9998 4.00066C11.9998 3.45066 12.4498 3.00069 12.9998 3.00074ZM5.99967 5.00016L5.99836 21.0002L19.9984 21.0013L19.9997 5.00131L17.9997 5.00115L17.9994 8.00115L7.99943 8.00033L7.99967 5.00033L5.99967 5.00016Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste24Px);
export default __webpack_public_path__ + "static/media/paste_24px.8ed61797e675970a7039256bd45e89e8.svg";
export { ForwardRef as ReactComponent };